import { Category } from "@insite/client-framework/Services/CategoryService";
import { getCategoryState } from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import { ProductLinks } from "@ucs/Components/Category/ProductsMenu";

export const isCategoryLvl1 = (url: string) => {
    if(url.includes("/brands")){
        return url.split("/").length - 1 === 4;
    }
    return url.split("/").length - 1 === 2;
};

export enum CategoriesLvl1 {
    TYPE = "Type",
    APPLICATION = "Application",
}

export enum ApplicationCategories {
    Interiors = "Interiors",
    Exteriors = "Exteriors",
    BuildingEnvelope = "Building Envelope",
}

export const getPrductMenuLinks = (categoriesList: Category[], categoryName: string) => {
    const links: ProductLinks[] = [];
    const categories = categoriesList.filter(cat => isCategoryLvl1(cat["path"]));
    categories.forEach(cat => {
        links.push({
            url: cat["path"],
            name: cat["name"],
            isActive: cat["name"] === categoryName,
        });
    });
    links.push({
        url: "/brands",
        name: "Brands",
        isActive: categoryName === "Brands",
    });
    return links;
};

export const getChildCategories = (categoriesList: Category[], subCategoryIds: string[]) => {
    return categoriesList.filter(cat => subCategoryIds.includes(cat.id));
};
